/**
 * Created by osirvent on 18/11/2015.
 */
angular
    .module('annexaApp')
    .constant('TerritoryModals', {
    	addressNew: {
            title: 'global.territory.list.new',
            size: 'modal-xl',
            icon: 'fa fa-at',
            annexaFormly: {
                fields: [
                	{
                        key: 'row_address',
                        className: 'row',
                        templateOptions: {},
                        fieldGroup: [
                        ],
                        wrapper: 'annexaRow'
                    }
                ]
            },
            submitModal: function () {
            },
            alerts: []
        },
        addressIdentificationReferencesAdd: {
	       title: 'global.literals.newIdentificationReference',
	       size: '',
	       icon: 'fa fa-tag',
	       annexaFormly: {
	    	   fields: [
	    		   {
	                   key: 'modal_body',
	                   className: 'modal-body p-lg',
	                   fieldGroup: [
	                       {
	                           key: 'addressIdentificationReferenceType',
	                           type: 'annexaSelectRow',
	                           className: 'col-sm-12',
	                           data: {
	                               informed:true,
	                               row:true,
	                               colClass: '',
	                               labelClass: 'label-strong',
	                               clear: function($event,model,key, $select) {
	                                   $event.stopPropagation();
	                                   model[key] = undefined;
	                                   if($select) {
	                                       $select.selected = undefined;
	                                       $select.search = undefined;
	                                   }
	                               }
	                           },
	                           templateOptions: {
	                               optionsAttr: 'bs-options',
	                               ngOptions: 'option in to.options | filter: $select.search',
	                               label: 'global.literals.type',
	                               valueProp: 'id',
	                               labelProp: 'name',
	                               placeholder: '',
	                               options: [],
	                               required: true,
	                               focus: false
	                           },
	                           controller: ['$scope', '$filter', 'GlobalDataFactory', 'Language', function($scope, $filter, GlobalDataFactory, Language) {
	                           	$scope.to.options = angular.copy(GlobalDataFactory.addressIdentificationReferenceTypes);
	                           	$scope.to.labelProp = Language.getActiveColumn();
	                           }]
	                       },
							{
		                        key: 'identificationReference',
		                        type: 'annexaInputRow',
		                        className: 'col-sm-12',
		                        data: {
		                            row: true,
		                            colClass: '',
		                            labelClass: 'label-strong',
		                            informed: true
		                        },
		                        templateOptions: {
		                            type: 'text',
		                            label: 'global.territory.list.identification_reference',
		                            required: true,
		                            focus: false
	                           }
	                       }
	                   ]
	               }
	           ]
	       }
	   },
	   addressIdentificationReferencesEdit: {
	       title: 'global.literals.editIdentificationReference',
	       size: '',
	       icon: 'fa fa-tag',
	       annexaFormly: {
	           fields: [
	               {
	                   key: 'modal_body',
	                   className: 'modal-body p-lg',
	                   fieldGroup: [
	                       {
	                           key: 'addressIdentificationReferenceType',
	                           type: 'annexaSelectRow',
	                           className: 'col-sm-12',
	                           data: {
	                               informed:true,
	                               row:true,
	                               colClass: '',
	                               labelClass: 'label-strong',
	                               clear: function($event,model,key, $select) {
	                                   $event.stopPropagation();
	                                   model[key] = undefined;
	                                   if($select) {
	                                       $select.selected = undefined;
	                                       $select.search = undefined;
	                                   }
	                               }
	                           },
	                           templateOptions: {
	                               optionsAttr: 'bs-options',
	                               ngOptions: 'option in to.options | filter: $select.search',
	                               label: 'global.literals.type',
	                               valueProp: 'id',
	                               labelProp: 'name',
	                               placeholder: '',
	                               options: [],
	                               required: true,
	                               focus: false
	                           },
	                           controller: ['$scope', '$filter', 'GlobalDataFactory', 'Language', function($scope, $filter, GlobalDataFactory, Language) {
	                           	$scope.to.options = angular.copy(GlobalDataFactory.addressIdentificationReferenceTypes);
	                           	$scope.to.labelProp = Language.getActiveColumn();
	                           }]
	                       	},
							{
		                        key: 'identificationReference',
		                        type: 'annexaInputRow',
		                        className: 'col-sm-12',
		                        data: {
		                            row: true,
		                            colClass: '',
		                            labelClass: 'label-strong',
		                            informed: true
		                        },
		                        templateOptions: {
		                            type: 'text',
		                            label: 'global.territory.list.identification_reference',
		                            required: true,
		                            focus: false
	                           	}
							}
						]
					}
				]
			}
       }
   }
);